import { useMutation } from "react-query";
import { post } from "shared/data";

export const useAddClientSla = () => {
    return useMutation("addClientSla", {
        mutationFn: (payload) => post("/sla/client", payload),
    });
};
